import { render, staticRenderFns } from "./Loginform.vue?vue&type=template&id=7a65e404&scoped=true&"
import script from "./Loginform.vue?vue&type=script&lang=js&"
export * from "./Loginform.vue?vue&type=script&lang=js&"
import style0 from "./Loginform.vue?vue&type=style&index=0&id=7a65e404&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a65e404",
  null
  
)

export default component.exports